import React from 'react';
import PropTypes from 'prop-types';
function Guests({ adults, infantsAndAges, childrenAndAges })
{
    const description = () =>
    {
        let sep = '';
        let res = '';

        if (adults > 0)
        {
            res = `${adults} Adults`;
            sep = ', ';
        }
        if (infantsAndAges > 0)
        {
            res = `${res + sep + infantsAndAges.length} Infants`;
            sep = ', ';
        }
        if (childrenAndAges > 0)
        {
            res = `${res + sep + childrenAndAges.length} Childrens`;
        }
        return res;
    };
    return (
        <>
            {description()}
        </>
    );
}

Guests.propTypes = {
    adults: PropTypes.number,
    infantsAndAges: PropTypes.array,
    childrenAndAges: PropTypes.array,
};

Guests.defaultProps = {
};
export default Guests;
